import Button from '@repo/ui/button'
import { OptionIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'
import { useState } from 'react'

import { FamilyArrangementEnum } from '../../../../lib/types/enums/ol/family-arrangement.enum'

type Props = {
  isOpen: boolean
  onClose: () => void
  onSubmit: (familyArrangement: FamilyArrangementEnum) => void
}

const EnrollmentPropositionFamilyArrangementModal = ({ isOpen, onClose, onSubmit }: Props) => {
  const [familyArrangement, setFamilyArrangement] = useState<FamilyArrangementEnum>()

  return (
    <Modal
      isOpen={isOpen}
      title="Modalités d'accueil"
      icon={OptionIcon}
      size="medium"
      hideActions
      disableOutSideClick
      onCancel={onClose}
    >
      <div className={`${MODAL_BODY_CLASSNAME} flex flex-col gap-4`}>
        <Typography variant="label-medium">
          Ce séjour propose les deux modalités d'accueil, veuillez en choisir une pour continuer.
        </Typography>
        <RadioInput
          label="Un français par famille"
          checked={familyArrangement === FamilyArrangementEnum.FA1E}
          onCheck={() => setFamilyArrangement(FamilyArrangementEnum.FA1E)}
        />
        <RadioInput
          label="Deux français par famille"
          checked={familyArrangement === FamilyArrangementEnum.FA2E}
          onCheck={() => setFamilyArrangement(FamilyArrangementEnum.FA2E)}
        />
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" label="Annuler" onClick={onClose} />
          <Button
            type="button"
            label="Valider"
            disabled={!familyArrangement}
            onClick={() => familyArrangement && onSubmit(familyArrangement)}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EnrollmentPropositionFamilyArrangementModal
